
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/clear-background",
      function () {
        return require("private-next-pages/clear-background/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/clear-background"])
      });
    }
  